import {createBrowserRouter, redirect} from 'react-router-dom';
import {Header, StepHeader} from '@/components/router';
import loaders from '@/query/loaders';
import {Strings} from '@/assets';
import ErrorElement from './pages/ErrorElement';

const router = createBrowserRouter([
  {
    path: '/',
    ErrorBoundary: ErrorElement,
    loader: () => {
      if (import.meta.env.DEV) {
        return redirect('/development/');
      } else if (import.meta.env.VITE_BASE_URL) {
        return redirect('/staging/');
      } else {
        return new Response(null, {status: 500});
      }
    },
  },
  {
    path: '/:country/',
    element: <Header />,
    loader: loaders.meta,
    ErrorBoundary: ErrorElement,
    children: [
      {
        path: '',
        async lazy() {
          const Component = await import('./pages/NewVisaRequest');
          return {Component: Component.default};
        },
        ErrorBoundary: ErrorElement,
      },
      {
        path: 'visa_requests/:visa_request_id/visitor/:visitor_id/',
        element: <StepHeader />,
        loader: loaders.visa_request,
        ErrorBoundary: ErrorElement,
        children: [
          {
            path: Strings.ROUTES.PASSPORT,
            loader: loaders.redirection,
            ErrorBoundary: ErrorElement,
            async lazy() {
              const Component = await import('./pages/PassportDetails');
              return {Component: Component.default};
            },
          },
          {
            path: Strings.ROUTES.VISA,
            loader: loaders.redirection,
            ErrorBoundary: ErrorElement,
            async lazy() {
              const Component = await import('./pages/VisaDetails');
              return {Component: Component.default};
            },
          },
          {
            path: Strings.ROUTES.FINANCIAL,
            loader: loaders.redirection,
            ErrorBoundary: ErrorElement,
            async lazy() {
              const Component = await import('./pages/FinancialDetails');
              return {Component: Component.default};
            },
          },
          {
            path: Strings.ROUTES.ADDITIONAL,
            loader: loaders.redirection,
            ErrorBoundary: ErrorElement,
            async lazy() {
              const Component = await import('./pages/AdditionalDetails');
              return {Component: Component.default};
            },
          },
          {
            path: Strings.ROUTES.SUCCESS,
            loader: loaders.redirection,
            ErrorBoundary: ErrorElement,
            async lazy() {
              const Component = await import('./pages/SuccessDetails');
              return {Component: Component.default};
            },
          },
          {
            path: Strings.ROUTES.PAYMENT,
            loader: loaders.redirection,
            ErrorBoundary: ErrorElement,
            async lazy() {
              const Component = await import('./pages/PaymentDetails');
              return {Component: Component.default};
            },
          },
          {
            path: Strings.ROUTES.EXPIRED,
            loader: loaders.redirection,
            ErrorBoundary: ErrorElement,
            async lazy() {
              const Component = await import('./pages/ErrorElement');
              return {Component: Component.default};
            },
          },
          {
            path: Strings.ROUTES.PREVIEW,
            loader: loaders.redirection,
            ErrorBoundary: ErrorElement,
            async lazy() {
              const Component = await import('./pages/VisaRequestPreview');
              return {Component: Component.default};
            },
          },
        ],
      },
      {
        path: 'visa_applications/:visa_application_token/',
        ErrorBoundary: ErrorElement,
        async lazy() {
          const Component = await import('./pages/VisaApplicationToken');
          return {Component: Component.default};
        },
        loader: loaders.visa_application,
      },
    ],
  },
]);

export default router;
